import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    isAddPlaceholderInLeftPanelOfTableCtrls: {
        type: 'boolean',
        title: 'Add placeholder in left panel of table controls',
        description: '',
    },
    isAddPlaceholderInRightPanelOfTableCtrls: {
        type: 'boolean',
        title: 'Add placeholder in right panel of table controls',
        description: '',
    },
    isAddPlaceholderInBottomPanelOfTableCtrls: {
        type: 'boolean',
        title: 'Add placeholder in bottom panel of table controls',
        description: '',
    },
};

const uiSchema = {
    isAddPlaceholderInLeftPanelOfTableCtrls: { 'ui:widget': 'CustomCheckbox' },
    isAddPlaceholderInRightPanelOfTableCtrls: { 'ui:widget': 'CustomCheckbox' },
    isAddPlaceholderInBottomPanelOfTableCtrls: { 'ui:widget': 'CustomCheckbox' },
};

const tableCntrlsPlaceholdersSchema = {
    schema,
    uiSchema,
};

export default tableCntrlsPlaceholdersSchema;
